
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.233 22.667L19 17.9l4.767 4.767 2.566-2.567-4.766-4.766 4.766-4.767L23.767 8 19 12.767 14.233 8l-2.567 2.567 4.767 4.767-4.767 4.766 2.567 2.567zM.667 37.334v-33c0-1.009.359-1.872 1.077-2.59.718-.718 1.58-1.077 2.59-1.077h29.332c1.009 0 1.872.359 2.59 1.077.718.718 1.077 1.581 1.077 2.59v22c0 1.008-.359 1.871-1.077 2.59-.718.717-1.581 1.076-2.59 1.076H8L.667 37.334zm5.774-11h27.226v-22H4.332v24.062l2.108-2.062z","fill":"#a3a3a3"}})])
          )
        }
      }
    